import React, { useContext, useEffect, useState } from 'react';
import ZoomViewBox from '@/pages/OrderDetailPage/containers/ZoomViewBox';
import ZoomController from '@/pages/OrderDetailPage/containers/ZoomController';
import styled from 'styled-components';
import TextComponent from '@/components/TextComponent';
import { useRecoilState } from 'recoil';
import { configState } from '@/recoil/config';
import ZoomAreaBox from '@/pages/OrderDetailPage/containers/ZoomAreaBox';

const INITIAL_DATA = {
  viewScale: 3,
  areaScale: 0,
  shown: false,
  offset: { left: 0, top: 0 },
  boxOffset: { left: 0, top: 0 },
  uri: '',
  filetype: '',
  update: (value: any) => {}
};
type ZoomBoxType = Omit<typeof INITIAL_DATA, 'update'>;

export const ZoomBoxContext = React.createContext(INITIAL_DATA);

interface ZoomAreaBoxProps {
  offset: { left: number; top: number };

  onClick(): void;
}

export const PreviewZoomAreaBox = ({ offset, onClick }: ZoomAreaBoxProps) => {
  const { update } = useContext(ZoomBoxContext);
  const zoomBoxContext = useContext(ZoomBoxContext);

  const [zoomView, setZoomView] = useState(false);
  const _setZoomView = (offset: { left: number; top: number }) => {
    const pageX = offset.left;
    const pageY = offset.top;
    const rect = { top: { x: 436, y: 234 }, bottom: { x: 854, y: 838 } };

    const _shown =
      pageX > rect.top.x &&
      pageX < rect.bottom.x &&
      pageY > rect.top.y &&
      pageY < rect.bottom.y;
    setZoomView(_shown);
    update({
      shown: _shown
    });
  };

  useEffect(() => {
    _setZoomView(offset);
    update({ offset });
  }, [offset]);

  return (
    <div>
      <ZoomAreaBox
        shown={zoomView}
        scale={zoomBoxContext.areaScale}
        offset={offset}
        onClick={() => {
          update({ shown: false });
          onClick();
        }}
        onChange={boxOffset => update({ boxOffset })}
      />
    </div>
  );
};

interface ZoomViewBoxProps {
  uri: string;
  filetype: string;
  offset: { left: number; top: number };
}

export const PreviewZoomViewBox = ({ uri, filetype }: ZoomViewBoxProps) => {
  const zoomBoxContext = useContext(ZoomBoxContext);

  return (
    <div>
      <ZoomViewBox
        viewScale={zoomBoxContext.viewScale}
        areaScale={zoomBoxContext.areaScale}
        shown={zoomBoxContext.shown}
        offset={zoomBoxContext.boxOffset}
        uri={uri}
        fileType={filetype}
      />
    </div>
  );
};

export const PreviewZoomAreaBoxController = () => {
  const { update } = useContext(ZoomBoxContext);
  const zoomBoxContext = useContext(ZoomBoxContext);
  return (
    <ZoomControllerWrapper>
      <TextComponent fontWeight={400} fontSize={13}>
        처방전 확대영역
      </TextComponent>
      <ZoomController
        scale={zoomBoxContext.areaScale}
        sliderColor={'orange'}
        onChange={value => update({ areaScale: value })}
      />
    </ZoomControllerWrapper>
  );
};

export const PreviewZoomViewBoxController = () => {
  const { update } = useContext(ZoomBoxContext);
  const zoomBoxContext = useContext(ZoomBoxContext);
  return (
    <ZoomControllerWrapper style={{ flex: 1 }}>
      <TextComponent fontWeight={400} fontSize={13}>
        확대영역 크기
      </TextComponent>
      <ZoomController
        scale={zoomBoxContext.viewScale}
        sliderColor={'green'}
        onChange={value => update({ viewScale: value })}
      />
    </ZoomControllerWrapper>
  );
};

interface Props {
  children: JSX.Element[];
}

export default function ZoomBox({ children }: Props) {
  const [config, setConfig] = useRecoilState(configState);
  const [value, setValue] = useState<ZoomBoxType>({
    ...INITIAL_DATA,
    ...config.history.zoomBox
  });
  const _setValue = (updateValue: Record<any, any>) => {
    const result = Object.assign(value, updateValue);
    if (
      value.viewScale !== updateValue.viewScale ||
      value.areaScale !== updateValue.areaScale
    ) {
      setConfig({
        ...config,
        history: {
          zoomBox: { viewScale: result.viewScale, areaScale: result.areaScale }
        }
      });
    }
    setValue(result);
  };

  return (
    <ZoomBoxContext.Provider value={{ ...value, update: _setValue }}>
      {children}
    </ZoomBoxContext.Provider>
  );
}

const ZoomControllerWrapper = styled.div`
  display: flex;
  line-height: 29px;

  & > * {
    &:nth-child(1) {
      flex: 1;
      text-align: right;
      padding-right: 1rem;
    }

    &:nth-child(2) {
      flex: none;
      width: 150px;
    }
  }
`;
